import { configureStore } from "@reduxjs/toolkit";
import productReducer from "../features/product/projectSlice";
import createProjectReducer from "../features/createProject/createProductSlice";
import validateFilesSlice from "../features/createProject/validateFilesSlice";
import snackbarReducer from "../features/snackbar/snackbarslice";
import loaderSlice from "../features/loader/loaderSlice";
import currentUserDetail from "../features/currentUser/currentUserSlice";
import { aptApiSlice } from '../services/api/clarityNav';
import { mvocSlice } from '../features/MVOC/mvocSlice';
import lookupReducer from "../features/Lookup/lookupSlice";
import ModalSlice from "../features/Modal/ModalSlice";


export const store = configureStore({
  reducer: {
    product: productReducer,
    createProjectDetails: createProjectReducer,
    snackbar: snackbarReducer,
    loader: loaderSlice,
    validateFiles: validateFilesSlice,
    currentUserDetail: currentUserDetail,
    lookup: lookupReducer,
    ModalSlice:ModalSlice,
    mvocSlice:mvocSlice.reducer,
    aptApiSlice: aptApiSlice.reducer,

  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(aptApiSlice.middleware),
});


export default store;
